import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';

import { Buttons } from '../Buttons';
import { RadioCardSubPage } from './RadioCardSubPage';
import QuestionnaireContext from '../../QuestionnaireContext';
import QuestionnaireNextButton from '../../QuestionnaireNextButton';

const useStyles = makeStyles({
  nextSubStep: {
    position: 'absolute',
    bottom: 9,
    right: 9,
  },
  subOptions: {
    maxWidth: '50%',
  },
});

const RadioCard = ({ options, questionId, onPush, onRemove }) => {
  const { setParam } = useContext(QuestionnaireContext);
  const classes = useStyles();
  const [subOptions, setSubOptions] = useState([]);
  const [subQuestionId, setSubQuestionId] = useState();
  const [subPage, setSubPage] = useState([]);
  const [step, setStep] = useState(0);

  const handleChange = selectedValues => {
    const hasSubOptions = !!options
      .filter(option => selectedValues.includes(option.answerId))
      .find(option => !isEmpty(option.options));

    options
      .filter(option => !selectedValues.includes(option.answerId))
      .forEach(option => {
        onRemove(option.questionId);
      });

    setSubOptions([]);

    if (!selectedValues.length) {
      setParam('isValidate', false);
    } else if (selectedValues.length && !hasSubOptions) {
      setParam('isValidate', true);
    } else {
      setParam('isValidate', false);
      selectedValues.forEach(answerId => {
        const subLevel = options.find(option => option.answerId === answerId);

        if (!isEmpty(subLevel.options)) {
          const subOptionsValues = values(subLevel.options);

          subOptionsValues.forEach(subOptionsValue => onRemove(subOptionsValue.questionId));
          setSubQuestionId(subLevel.questionId);
          setSubOptions(subOptionsValues);
        }
      });
    }
  };

  useEffect(() => {
    if (!subOptions.length) {
      setSubPage([]);
    }
  }, [subOptions]);

  const handleSubLevelChange = selectedValues => {
    const subPageValues = subOptions.filter(option => selectedValues.includes(option.answerId));
    setSubPage(subPageValues);
  };

  return subPage && step === 1 ? (
    <RadioCardSubPage data={subPage} onPush={onPush} onRemove={onRemove} />
  ) : (
    <>
      <Buttons
        options={options}
        questionId={questionId}
        onChange={handleChange}
        onPush={onPush}
        onRemove={onRemove}
        handleValidation={false}
        selectedAll={false}
      />
      {subOptions.length ? (
        <div className={classes.subOptions}>
          <Buttons
            options={subOptions}
            questionId={subQuestionId}
            onPush={onPush}
            onRemove={onRemove}
            handleValidation={false}
            onChange={handleSubLevelChange}
            selectedAll={false}
            className="sub-button"
          />
        </div>
      ) : null}
      {subPage.length ? (
        <QuestionnaireNextButton className={classes.nextSubStep} onClick={() => setStep(1)}>
          Next
        </QuestionnaireNextButton>
      ) : null}
    </>
  );
};

RadioCard.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      answerId: PropTypes.number.isRequired,
      answerLabel: PropTypes.string.isRequired,
      type: PropTypes.string,
    }),
  ).isRequired,
  questionId: PropTypes.number.isRequired,
  onPush: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export { RadioCard };
